import { render, staticRenderFns } from "./NumberGroupEditor.vue?vue&type=template&id=90dd762e"
import script from "./NumberGroupEditor.vue?vue&type=script&lang=js"
export * from "./NumberGroupEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports